import { Loader2 } from 'lucide-react';
import { useToast } from '../../hooks/useToast';
import styles from './TenantSelector.module.css';
import type { StatusIndicator, TenantOptionItemProps } from './types';

const INDICATOR_CLASS: Record<StatusIndicator, string> = {
  good: styles.statusOn,
  warning: styles.statusWarning,
  bad: styles.statusOff,
  neutral: styles.statusAvailable,
  hidden: styles.statusHidden,
};

export function TenantOptionItem({
  tenant,
  row: { isSelected, isSyncing, statusIndicator },
  disabled,
  onTenantSelectionChange,
}: TenantOptionItemProps) {
  const { addToast } = useToast();
  const cannotBeDeselected = statusIndicator?.lockReason !== undefined;

  const handleClick = () => {
    if (disabled) return;
    if (isSelected && cannotBeDeselected) {
      addToast({
        title: `${tenant.name} cannot be removed`,
        description: statusIndicator!.lockReason,
        variant: 'destructive',
      });
      return;
    }
    onTenantSelectionChange(tenant);
  };

  return (
    <li className={styles.option} onClick={handleClick}>
      <input type="checkbox" checked={isSelected} readOnly disabled={disabled} />
      <span className={styles.tenantName}>{tenant.name}</span>
      {isSyncing && <Loader2 className={styles.syncingSpinner} aria-label="Syncing" role="img" />}
      <span className={styles.statusCell}>
        {statusIndicator != null && (
          <span
            className={`${styles.badge} ${INDICATOR_CLASS[statusIndicator.indicator] ?? ''}`}
            title={statusIndicator.lockReason}>
            {statusIndicator.label}
          </span>
        )}
      </span>
    </li>
  );
}
